// extracted by mini-css-extract-plugin
module.exports = {"PageStyles":"_6z3lQ7lcJRvhL41xQGHxMA==","AnalysisFail":"CSGe+5S1JW-6u4MbM1lRtg==","Card":"WHPcDO-J4wDsEdRp3CJVcQ=="};